import React from "react";
import { Navbar, Nav, Button, Container, Dropdown } from "react-bootstrap";
import "./index.scss";
import { LogoIcon } from "../../../assets/icons/LogoIcon";
import { useLanguage } from "../../../contexts/LanguageContext";
import { getTranslation } from "../../../translations";

const Header = () => {
  const { language, changeLanguage } = useLanguage();

  const handleLanguageChange = (newLanguage) => {
    changeLanguage(newLanguage);
  };

  return (
    <Navbar expand="lg" fixed="top" className="header">
      <Container
        fluid
        className="width-container d-flex align-items-center justify-content-between">
        {/* Logo */}
        <Navbar.Brand href="#">
          <LogoIcon />
        </Navbar.Brand>

        {/* Toggle for mobile */}
        <div className="d-flex align-items-center gap-3">
          <Navbar.Toggle aria-controls="navbar-nav" />
          {/* Mobile language selector */}
          <Dropdown className="d-md-none d-block">
            <Dropdown.Toggle variant="link" className="lang-toggle">
              {language.toUpperCase()}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item 
                onClick={() => handleLanguageChange('fr')}
                active={language === 'fr'}
              >
                FR
              </Dropdown.Item>
              <Dropdown.Item 
                onClick={() => handleLanguageChange('en')}
                active={language === 'en'}
              >
                EN
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {/* Navigation menu */}
        <Navbar.Collapse id="navbar-nav" className="justify-content-end">
          <Nav className="align-items-center gap-3">
            <Nav.Link href="/#filiales" className="nav-item mb-3 mb-md-0">
              {getTranslation(language, 'filiales')}
            </Nav.Link>
            <Button href="/#contact" className="contact-btn mb-3 mb-md-0">
              {getTranslation(language, 'contact')}
            </Button>
            {/* Desktop language selector */}
            <Dropdown className="d-none d-md-block">
              <Dropdown.Toggle variant="link" className="lang-toggle">
                {language.toUpperCase()}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item 
                  onClick={() => handleLanguageChange('fr')}
                  active={language === 'fr'}
                >
                  FR
                </Dropdown.Item>
                <Dropdown.Item 
                  onClick={() => handleLanguageChange('en')}
                  active={language === 'en'}
                >
                  EN
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
